export default __webpack_public_path__ + "static/community-2-8373e6d5f3ee592fc9d6905e91fc25e1.png";